module.exports = __webpack_public_path__ + "img/极客数据团队-上层.6e475de2.png";